import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  styled,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Home, ArrowBack } from "@mui/icons-material";

const NotFoundWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.secondary.main}15 100%)`,
  padding: theme.spacing(3),
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  textAlign: "center",
  "& img": {
    maxWidth: "100%",
    height: "auto",
    marginBottom: theme.spacing(4),
  },
}));

const NotFound = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <NotFoundWrapper>
      <Container maxWidth="md">
        <ContentWrapper>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "4rem", md: "6rem" },
              fontWeight: "bold",
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 2,
            }}
          >
            404
          </Typography>

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              mb: 3,
              fontWeight: "medium",
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </Typography>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Home />}
              onClick={() => navigate("/")}
              sx={{ px: 3, py: 1 }}
            >
              Go Home
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBack />}
              onClick={() => navigate(-1)}
              sx={{ px: 3, py: 1 }}
            >
              Go Back
            </Button>
          </Box>
        </ContentWrapper>
      </Container>
    </NotFoundWrapper>
  );
};

export default NotFound;
